module.exports = __webpack_public_path__ + "static/media/star.4ca3c664.png";